// AOS (Animate On Scroll) initialization
import AOS from 'aos';
import 'aos/dist/aos.css';

// Helper function to check if device is desktop
function isDesktopAOS() {
    return window.matchMedia('(min-width: 1025px)').matches;
}

// Импортируем AOS CSS только для мобильных
if (isDesktopAOS()) {
    // На desktop сразу удаляем все AOS атрибуты до инициализации
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll("[data-aos]").forEach(el => {
            el.removeAttribute("data-aos");
            el.removeAttribute("data-aos-delay");
            el.removeAttribute("data-aos-duration");
            el.removeAttribute("data-aos-easing");
            el.removeAttribute("data-aos-offset");
            el.removeAttribute("data-aos-anchor-placement");
        });
        console.log('AOS attributes removed on desktop');
    });
}

// Initialize AOS only on mobile devices
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktopAOS()) {
        console.log('Initializing AOS for mobile');
        
        AOS.init({
            duration: 800,
            easing: 'ease-out',
            once: true,           // Анимация происходит только один раз
            mirror: false,        // Не повторять анимацию при обратном скролле
            offset: 100,
            delay: 0,
            disable: false,
            anchorPlacement: 'top-bottom'  // Триггер когда верх элемента достигает низа viewport
        });
        
        console.log('AOS initialized');
    }
});

// Refresh AOS on window resize
window.addEventListener('resize', function() {
    if (!isDesktopAOS() && typeof AOS !== 'undefined') {
        AOS.refresh();
    }
});

export default AOS;

